import React from 'react';
import classNames from 'classnames';

function Group({ id, type, size, isRequired, isHidden, hasMultiple, className, children }) {
  const groupClasses = classNames(
    'form__group',
    'js-form-group',
    className,
    {
      ['form__' + type]: type,
      ['form__group--' + size]: size,
      'form__group--multiple': hasMultiple,
      required: isRequired,
      hidden: isHidden
    },
    'gel-component'
  );

  return (
    <div id={id} className={groupClasses}>
      {children}
    </div>
  );
}

export default Group;
